import { render, staticRenderFns } from "./AdminSidebarComponent.vue?vue&type=template&id=26915a8a&"
import script from "./AdminSidebarComponent.vue?vue&type=script&lang=js&"
export * from "./AdminSidebarComponent.vue?vue&type=script&lang=js&"
import style0 from "./AdminSidebarComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports